// extracted by mini-css-extract-plugin
export default {"announcements":"br_Qn p-2","announcement":"br_Qp card my-2","announcement--highlighted":"br_Qq","announcement__list-item":"br_Qr py-1","announcement__flag":"br_Qs"};